import BaseApi from './BaseApi';

export type UserMatch = {
  matchId: string;
  companyId: string;
  updateAt: number;
  clientUserId: string;
  isHideChannel: boolean;
  status: number;
  lineOfficialId: string;
  lastReadTimestampCompany: number;
  createAt: number;
  userId: string;
  lastReadTimestampLineUser: number;
  messageChannelArn: string;
  lastSenderId: string;
  lastChatTime: number;
  type: string;
};

/**
 * UserMatch一覧取得API。
 */
class GetUserMatchListApi extends BaseApi {
  async get(companyId: string) {
    return await this.execute('getUserMatchListApi', {
      method: 'POST',
      body: { companyId }
    }).then(({ result }) => result as UserMatch[]);
  }
}

export default GetUserMatchListApi;
